<template>
  <b-card>
    <b-row class="px-1 align-items-center justify-content-between">
      <h5> طلبات الإنتساب لمنظمة دولية </h5>
    </b-row>
    <hr />
    <data-table
      ep="v2/I-organisations-memberships"
      id="IOrganisationsmemberships"
      :fields="tableFields"
      ref="IOrganisationsmembershipsTable"
      @row-clicked="onRowClicked"
    >
      <template #cell(invitation_file)="{ value }" >
        <b-button
          size="sm"
          @click="$router.push({ name: 'file-view', query: { ep: value } })"
          variant="flat-success"
        >
          <feather-icon class="mx-25" icon="EyeIcon" />
          عرض الملف
        </b-button>
      </template>
      <template #cell(actions)="row">
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="flat-info"
            size="sm"
            class="btn-icon rounded-circle"
            title="عرض التبرع"
            @click="showDonations(row.item.id)"
          >
            <feather-icon icon="EyeIcon" size="1.8x" color="#82868b" />
          </b-button>
         
        </div>
      </template>
    </data-table>
  <show-i-organisations-member-ships
    v-model="isShow" 
    :initializeForm="form"
    ref="currentModalRef">
  </show-i-organisations-member-ships>
  </b-card>
</template>

<script>
import { BCard, BRow, BButton , VBTooltip ,BCol} from "bootstrap-vue";
import DataTable from "@/components/data-table";
import { mapGetters, mapActions } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import ShowIOrganisationsMemberShips from "../../components/ShowIOrganisationsMemberShips.vue"

export default {
  components: {
    BCard,
    BRow,
    DataTable,
    BButton,
    VBTooltip,
    BCol,
    ShowIOrganisationsMemberShips
  },
  data() {
    return {
      isShow : false ,
      form : {} ,
      id: null,
      tableFields: [
        { key: "id", label: "المعرف" },
        { key: "name", label: "اسم المنظمة الدولية" },
        { key: "address", label: "مجال عمل المنظمة الدولية" },
        { key: "country.name", label: "الدولة" },
        { key: "field_of_work", label: "العنوان" },
        { key: "actions", label: " " },
      ],
    };
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  methods: {
    ...mapActions("UNCoop", ["deleteProject"]),
    onDeleteClicked(id) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف مشروع التعاون", {
          title: "تأكيد الحذف",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.deleteProject(id).then(() => {
              this.$refs.IOrganisationsmembershipsTable.refreshTable();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "تم حذف المشروع بنجاح ",
                  icon: "CheckSquareIcon",
                  variant: "success",
                },
              });
            });
          }
        });
    },
    onRowClicked(val) {
      this.$router.push(`/un-coop/projects/${val.id}`);
    },
    
    async showDonations(id){
      console.log("id" , id)
      
      this.$refs.currentModalRef.init({'id' : id})
      this.isShow = true
    },
  },
  computed: {
    ...mapGetters("UNCoop", ["working"]),
  },
};
</script>
